import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { bookingexternal, trialmanagementexternal, vetaichatexternal } from 'src/shared/services/client/client';
import { ClientService } from 'src/shared/services/client/client.service';

@Injectable({
  providedIn: 'root',
})
export class ChatDataService {
  clientService = inject(ClientService);
  recommendedProductsSubject: Subject<any> = new Subject();
  recommendedProductsObservable: Observable<any> = this.recommendedProductsSubject.asObservable();

  GetToken() {
    return this.clientService.requestWithClient((client) => client.bookingexternal.GetToken('me'));
  }

  ListMyChats() {
    return this.clientService.requestWithClient((client) => client.bookingexternal.ListChats('me'));
  }

  CreateChat(params: bookingexternal.CreateChatRequest) {
    return this.clientService.requestWithClient((client) => client.bookingexternal.CreateChat('me', params));
  }
  CreateTrialChat(trial_doc_id: string, params: trialmanagementexternal.CreateTrialChatRequest) {
    return this.clientService.requestWithClient((client) =>
      client.trialmanagementexternal.CreateTrialChat(trial_doc_id, params)
    );
  }

  GetChat(chatId: string) {
    return this.clientService.requestWithClient((client) => client.bookingexternal.GetChat('me', chatId));
  }

  GetInternalChat(chatId: string) {
    return this.clientService.requestWithClient((client) => client.bookinginternal.GetChat(chatId));
  }

  SkipAIChat(chatId: string) {
    return this.clientService.requestWithClient((client) => client.vetaichatexternal.SkipChat('me', chatId));
  }

  EndChat(chatId: string) {
    return this.clientService.requestWithClient((client) => client.bookingexternal.EndChat('me', chatId));
  }

  StartWhatsappChat(
    pet_doc_id: string,
    user_doc_id: string,
    chat_service_id: string,
    whatsapp_user_doc_id: string,
    pet_name: string
  ) {
    let params: bookingexternal.CreateWhatsappChatRequest = {
      pet_doc_id: pet_doc_id,
      chat_service_id: chat_service_id,
      timezone: 'Europe/London',
      whatsapp_user_doc_id: whatsapp_user_doc_id,
      pet_name: pet_name,
    };
    return this.clientService.requestWithClient((client) =>
      client.bookingexternal.StartWhatsappChat(user_doc_id, params)
    );
  }

  HandleChatProductRecommendations(chatId: string) {
    this.recommendedProductsSubject.next(chatId);
  }

  ChatCallToActionCallback(params: vetaichatexternal.ChatCallToActionRequest) {
    return this.clientService.requestWithClient((client) => client.vetaichatexternal.ChatCallToActionCallback(params));
  }
}
